import { VIEWER_ADAPTERS } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/adapter_configs/base.js?vue3';
import {
  commitInlineDiscussionsAdapter,
  commitParallelDiscussionsAdapter,
  commitNoPreviewDiscussionsAdapter,
} from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/commit_discussions.js?vue3';
import { lineHighlightingAdapter } from '~/rapid_diffs/adapters/line_highlighting';
import { optionsMenuAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/options_menu.js?vue3';
import { commitDiffsOptionsMenuAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/commit_diffs_options_menu.js?vue3';
import { commitImageViewerAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/commit_image_viewer.js?vue3';
import { imageAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/image_viewer.js?vue3';

export const adapters = {
  ...VIEWER_ADAPTERS,
  no_preview: [...VIEWER_ADAPTERS.no_preview, commitNoPreviewDiscussionsAdapter],
  image: [...VIEWER_ADAPTERS.image.filter((a) => a !== imageAdapter), commitImageViewerAdapter],
  text_inline: [
    ...VIEWER_ADAPTERS.text_inline.filter((a) => a !== optionsMenuAdapter),
    commitDiffsOptionsMenuAdapter,
    commitInlineDiscussionsAdapter,
    lineHighlightingAdapter,
  ],
  text_parallel: [
    ...VIEWER_ADAPTERS.text_parallel.filter((a) => a !== optionsMenuAdapter),
    commitDiffsOptionsMenuAdapter,
    commitParallelDiscussionsAdapter,
    lineHighlightingAdapter,
  ],
};
